import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

export const ALL_PERIODS = [
  'THIS_MONTH',
  'LAST_MONTH',
  '6_MONTHS',
  'THIS_YEAR',
  'LAST_YEAR',
  'LIFETIME'
];

@Component({
  selector: 'app-datepicker-full',
  templateUrl: './datepicker-full.component.html',
  styleUrls: ['./datepicker-full.component.sass']
})
export class DatepickerFullComponent implements OnInit, OnChanges {
  @Input() dates = { start: null, end: null };
  @Input() period: string = null;
  // Which presets to offer, in order. Defaults to all of them.
  @Input() periods: string[] = ALL_PERIODS;
  // Clamps the manual range. `LIFETIME` spans them when both are set, instead of "no start".
  @Input() bounds: { min: any, max: any } = { min: null, max: null };
  @Output() changeDates = new EventEmitter();
  @Output() changePeriod = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.period && changes.period.currentValue) {
      this.setPeriod(changes.period.currentValue);
    }
  }

  onDateChange() {
    this.period = '';
    this.changeDates.emit({ ...this.dates, manually: true });
  }

  onSetPeriod(period) {
    this.setPeriod(period);
  }

  setPeriod(period) {
    const dates = this.preparePeriod(period);

    this.dates.start = dates.start ? new Date(dates.start) : null;
    this.dates.end = dates.end ? new Date(dates.end) : null;
    this.period = period;

    this.changePeriod.emit(period);
    this.changeDates.emit({ ...this.dates, manually: false });
  }

  periodLabel(period: string): string {
    return 'shared.date.period.' + period.replace(/_/g, '-').toLowerCase();
  }

  isPeriod(period) {
    return this.period === period;
  }

  preparePeriod(period) {
    let start = new Date();
    let end = new Date();

    function getDaysInMonth(year, month) {
      return new Date(year, month + 1, 0).getDate();
    }

    switch (period) {
      case 'THIS_MONTH':
        start.setDate(1);

        end.setDate(getDaysInMonth(end.getFullYear(), end.getMonth()));
      break;

      case 'LAST_MONTH':
        // Set month and date at the same time to prevent month transition problems
        start.setMonth(start.getMonth() - 1, 1);
        // Calling setDate with value 0 set the date to the last day of the previous month
        end.setDate(0);
      break;

      case '6_MONTHS':
        start.setMonth(start.getMonth() - 6);
        start.setDate(1);

        end.setMonth(end.getMonth());
        end.setDate(getDaysInMonth(end.getFullYear(), end.getMonth()));
      break;

      case 'THIS_YEAR':
        start.setMonth(0);
        start.setDate(1);

        end.setMonth(11);
        end.setDate(31);
      break;

      case 'LAST_YEAR':
        start.setFullYear(end.getFullYear() - 1);
        start.setMonth(0);
        start.setDate(1);

        end.setFullYear(end.getFullYear() - 1);
        end.setMonth(11);
        end.setDate(31);
      break;

      case 'LIFETIME':
        // bounded callers (a single offer) mean a real span, not "everything ever"
        if (this.bounds.min || this.bounds.max) {
          start = this.bounds.min ? new Date(this.bounds.min) : null;
          end = this.bounds.max ? new Date(this.bounds.max) : end;
          break;
        }

        start = null;
        end.setDate(getDaysInMonth(end.getFullYear(), end.getMonth()));
      break;

      default:
        start = null;
        end = null;
    }

    return {
      start, end
    };
  }
}
